import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-955ef48a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      ((_ctx.data || []).length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createVNode(_component_Table, {
              data: _ctx.data,
              columns: _ctx.columns,
              bordered: true,
              pagination: _ctx.pagination
            }, null, 8, ["data", "columns", "pagination"])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_2, [
            _createVNode(_component_Nodata, { customdesc: '该股暂无研究报告' })
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}